/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie = function (b, j, m) {
  if (typeof j != "undefined") {
    m = m || {};
    if (j === null) {
      j = "";
      m.expires = -1;
    }
    var e = "";
    if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
      var f;
      if (typeof m.expires == "number") {
        f = new Date();
        f.setTime(f.getTime() + m.expires * 24 * 60 * 60 * 1000);
      } else {
        f = m.expires;
      }
      e = "; expires=" + f.toUTCString();
    }
    var l = m.path ? "; path=" + m.path : "";
    var g = m.domain ? "; domain=" + m.domain : "";
    var a = m.secure ? "; secure" : "";
    document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("");
  } else {
    var d = null;
    if (document.cookie && document.cookie != "") {
      var k = document.cookie.split(";");
      for (var h = 0; h < k.length; h++) {
        var c = jQuery.trim(k[h]);
        if (c.substring(0, b.length + 1) == b + "=") {
          d = decodeURIComponent(c.substring(b.length + 1));
          break;
        }
      }
    }
    return d;
  }
};

/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

Shopify.Products = (function () {
  var config = {
    howManyToShow: 3,
    howManyToStoreInMemory: 10,
    wrapperId: "recently-viewed-products",
    templateId: "recently-viewed-product-template",
    layout: "slider",
    swipe: true,
    media: "adapt",
    onComplete: null,
  };
  var productHandleQueue = [];
  var wrapper = null;
  var template = null;
  var shown = 0;
  var cookie = {
    configuration: {
      expires: 90,
      path: "/",
      domain: window.location.hostname,
    },
    name: "shopify_recently_viewed",
    write: function (recentlyViewed) {
      jQuery.cookie(this.name, recentlyViewed.join(" "), this.configuration);
      localStorage.setItem(
        this.name,
        recentlyViewed.join(" "),
        this.configuration
      );
    },
    read: function () {
      var recentlyViewed = [];
      var cookieValue = jQuery.cookie(this.name);
      if (Shopify.designMode && !cookieValue) {
        cookieValue = localStorage.getItem("shopify_recently_viewed");
      }
      if (cookieValue !== null) {
        recentlyViewed = cookieValue.split(" ");
      }
      return recentlyViewed;
    },
    destroy: function () {
      jQuery.cookie(this.name, null, this.configuration);
    },
    remove: function (productHandle) {
      var recentlyViewed = this.read();
      var position = jQuery.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    },
  };

  var finalize = function () {
    var items = wrapper.find(".item");
    if (items.length <= 2)
      $("#recently-viewed-products-list").addClass("center");

    $("#recently-viewed-products-list-2").addClass("recently-viewed-loaded");

    wrapper.show();
    // If we have a callback.
    if (config.onComplete) {
      try {
        config.onComplete();
      } catch (error) {}
    }
  };

  var moveAlong = function (wrapperP) {
    if (productHandleQueue.length && shown < config.howManyToShow) {
      var url =
        window.routes.root +
        "/products/" +
        productHandleQueue[shown] +
        "?view=ajax_recently_viewed";

      jQuery.ajax({
        type: "get",
        url: url,
        cache: false,
        success: function (product) {
          if (productHandleQueue[shown] !== "") wrapperP.append(product);
          shown++;
          moveAlong(wrapperP);
        },
        error: function () {
          cookie.remove(productHandleQueue[shown]);
          shown++;
          moveAlong(wrapperP);
        },
      });
    } else {
      finalize();
    }
  };

  var carouselOptions = function () {
    return {
      slidesPerView: 1.25,
      loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        450: {
          slidesPerView: 1.2,
        },
        551: {
          slidesPerView: 1.8,
        },
        767: {
          slidesPerView: 2.4,
        },
        992: {
          slidesPerView: 3.2,
        },
        1024: {
          slidesPerView: 3.25,
        },
        1200: {
          slidesPerView: 4,
        },
        1400: {
          slidesPerView: 4.25,
        },
        1600: {
          slidesPerView: 5,
        },
      },
    };
  };

  var initCarousel = function (carousel) {
    if (!carousel || typeof Swiper === "undefined") return null;
    return carousel.swiper || new Swiper(carousel, carouselOptions());
  };

  // The section renders one form per card, so ids/names have to be made unique
  // per section once the card markup lands.
  var scopeFormIdsToSection = function ($slide, sectionId) {
    $slide
      .find(".card .variants-popup-content .selector-wrapper .swatch-element")
      .each(function () {
        const $input = $(this).find("input");
        const $label = $(this).find("label");

        $input.attr({
          id: ($input.attr("id") || "") + sectionId,
          name: ($input.attr("name") || "") + sectionId,
        });
        $label.attr("for", ($label.attr("for") || "") + sectionId);
      });

    $slide.find(".card").each(function () {
      const $qsForm = $(this).find(".variants-popup-content form");
      const $acForm = $(this).find(".card-action form");
      const $select = $(this).find(".variants-popup-content select");
      const $acButton = $(this).find(".card-action form button");
      const $qsButton = $(this).find(
        ".variants-popup-content .product-card__button2 button"
      );

      $qsForm.attr("id", ($qsForm.attr("id") || "") + sectionId);
      $acForm.attr("id", ($acForm.attr("id") || "") + sectionId);
      $select.attr("id", ($select.attr("id") || "") + sectionId);
      $acButton.attr(
        "data-form-id",
        ($acButton.attr("data-form-id") || "") + sectionId
      );
      $qsButton.attr(
        "data-form-id",
        ($qsButton.attr("data-form-id") || "") + sectionId
      );
    });
  };

  var fetchProduct = function (handle) {
    return new Promise(function (resolve) {
      jQuery.ajax({
        type: "get",
        url:
          window.routes.root +
          "/products/" +
          handle +
          "?view=ajax_section_recently_viewed",
        cache: false,
        success: resolve,
        // One unavailable product must not hold back the rest of the carousel.
        error: function (xhr) {
          console.log(handle + " " + xhr.statusText);
          resolve(null);
        },
      });
    });
  };

  var doAlong = function (wrapperS) {
    const recentlyViewed = wrapperS.parents(".halo-recently-viewed-block");
    const sectionId = recentlyViewed.attr("sectionid");
    const carousel = wrapperS[0] && wrapperS[0].parentElement;
    const handles = productHandleQueue
      .slice(0, config.howManyToShow)
      .filter((handle) => handle !== "");

    if (!handles.length) {
      recentlyViewed.hide();
      return;
    }

    // Build the carousel first, over the placeholder slides the section rendered.
    // Swiper then owns the row geometry for the whole load, so a half-filled list
    // can never lay itself out wider than the section.
    let carouselSwiper =
      config.layout == "slider" ? initCarousel(carousel) : null;
    let placeholdersRemoved = false;
    let appended = 0;

    const removePlaceholders = () => {
      if (placeholdersRemoved) return;
      placeholdersRemoved = true;

      if (!carouselSwiper) {
        wrapperS
          .find(".product-item--loadingNoInfo")
          .parents(".product")
          .remove();
        return;
      }

      const indexes = [];
      carouselSwiper.slides.forEach((slide, index) => {
        if (slide.querySelector(".product-item--loadingNoInfo"))
          indexes.push(index);
      });

      if (indexes.length) carouselSwiper.removeSlide(indexes);
    };

    const appendProduct = (html) => {
      const holder = document.createElement("div");
      holder.innerHTML = html.trim();

      const slide = holder.firstElementChild;
      if (!slide) return;

      scopeFormIdsToSection($(slide), sectionId);

      // Append through Swiper so it measures and positions the new slide, then
      // drop the placeholders now that a real card is in.
      if (carouselSwiper) {
        carouselSwiper.appendSlide(slide);
      } else {
        wrapperS.append(slide);
      }

      appended++;
      removePlaceholders();
    };

    // Request every product at once, but append them in the order they were
    // viewed so the carousel fills in without reshuffling.
    const requests = handles.map(fetchProduct);

    requests
      .reduce(
        (queue, request) =>
          queue.then(() =>
            request.then((product) => {
              if (product) appendProduct(product);
            })
          ),
        Promise.resolve()
      )
      .then(() => {
        if (!appended) {
          recentlyViewed.hide();
          return;
        }

        removePlaceholders();

        // Swiper may not have been parsed yet when the block came into view.
        if (!carouselSwiper && config.layout == "slider") {
          carouselSwiper = initCarousel(carousel);
        }

        $(carousel).addClass("recently-viewed-loaded");

        if ($("body").hasClass("product-card-layout-08")) {
          window.sharedFunctions?.productCountdownCard();
        }

        window.sharedFunctions?.swapHoverVideoProductCard();

        // NOTE: config.onComplete is deliberately not called here. The section
        // passes a callback that rewrites the cookie with the (1 day) expiry
        // setting, and this path has never run it — wiring it up now would start
        // expiring browsing history much sooner than it does today.
      });
  };

  return {
    resizeImage: function (src, size) {
      if (size == null) {
        return src;
      }

      if (size == "master") {
        return src.replace(/http(s)?:/, "");
      }

      var match = src.match(
        /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i
      );

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
      } else {
        return null;
      }
    },

    showRecentlyViewed: function (params) {
      var params = params || {};

      // Update defaults.
      jQuery.extend(config, params);

      // Read cookie.
      productHandleQueue = cookie.read();

      // Template and element where to insert.
      template = config.templateId;
      wrapper = jQuery("#" + config.wrapperId);

      // How many products to show.
      config.howManyToShow = Math.min(
        productHandleQueue.length,
        config.howManyToShow
      );

      // If we have any to show.
      if (config.howManyToShow && wrapper.length) {
        // Getting each product with an Ajax call and rendering it on the page.
        if (template == "recently-viewed-product-popup") {
          const wrapperP = wrapper;
          moveAlong(wrapperP);
        } else {
          const wrapperS = wrapper;
          doAlong(wrapperS);
        }
      }
    },

    getConfig: function () {
      return config;
    },

    clearList: function () {
      cookie.destroy();
    },

    recordRecentlyViewed: function (params) {
      var params = params || {};

      // Update defaults.
      jQuery.extend(config, params);

      // Read cookie.
      var recentlyViewed = cookie.read();

      // If we are on a product page.
      if (window.location.pathname.indexOf("/products/") !== -1) {
        // What is the product handle on this page.
        var splitted = window.location.pathname.match(
          /\/products\/([a-z0-9\-_]+)/
        );
        if (splitted == null) {
          var productHandle = decodeURIComponent(
            window.location.pathname.split("/products/")[1]
          );
        } else {
          var productHandle = window.location.pathname.match(
            /\/products\/([a-z0-9\-_]+)/
          )[1];
        }
        // In what position is that product in memory.
        var position = jQuery.inArray(productHandle, recentlyViewed);
        // If not in memory.
        if (position === -1) {
          // Add product at the start of the list.
          recentlyViewed.unshift(productHandle);
          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(
            0,
            config.howManyToStoreInMemory
          );
        } else {
          // Remove the product and place it at start of list.
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }

        // Update cookie.
        cookie.write(recentlyViewed);
      }
    },
  };
})();
